import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
export const ModalContainer = styled.div`
  padding: ${({ theme }) => theme.spaces.padding.xl}
    ${({ theme }) => theme.spaces.padding.lg};
  color: ${({ theme }) => theme.system.neutral.text.primary};
  font-family: inherit;

  ${mediaQuery.xs} {
    padding: ${({ theme }) => theme.spaces.padding.lg}
      ${({ theme }) => theme.spaces.padding.lg};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spaces.gap.md};
`;

export const Title = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.sizes.xxl};
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  letter-spacing: -0.02em;

  ${mediaQuery.xs} {
    font-size: ${({ theme }) => theme.typography.sizes.xl};
  }
`;

export const CloseButton = styled.button`
  flex-shrink: 0;
  border: none;
  background: transparent;
  padding: ${({ theme }) => theme.spaces.padding.xs};
  margin: -4px -4px 0 0;
  line-height: 0;
  font-size: 18px;
  cursor: pointer;
  color: ${({ theme }) => theme.system.neutral.text.primary};

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.system.neutral.text.primary};
    outline-offset: 2px;
    border-radius: ${({ theme }) => theme.radius.small};
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spaces.gap.md};
  margin-top: ${({ theme }) => theme.spaces.gap.lg};

  ${mediaQuery.xs} {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;

export const BodyText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.gap.md};
  margin: ${({ theme }) => theme.spaces.gap.md} 0 0;
  font-size: ${({ theme }) => theme.typography.sizes.md};
  line-height: ${({ theme }) => theme.typography.lineHeight.base};
  color: ${({ theme }) => theme.system.neutral.text.primary};

  p {
    margin: 0;
  }
`;

export const ConsentWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spaces.gap.md};
`;

export const CheckboxGroupWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.gap.sm};

  label {
    align-items: flex-start;

    span {
      margin-top: ${({ theme }) => theme.spaces.padding.xs};
    }
  }
`;

export const CheckboxWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spaces.padding.xs};
  width: 20px;
`;

export const EnrollmentFooter = styled(Footer)`
  border-top: 1px solid ${({ theme }) => theme.system.neutral.border.subtle};
  margin-top: ${({ theme }) => theme.spaces.gap.lg};
  padding-top: ${({ theme }) => theme.spaces.padding.lg};
`;

export const CheckboxLabelWrapper = styled.div`
  width: 100%;
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  font-size: ${({ theme }) => theme.typography.sizes.md};
`;
